import { ca } from '@cian/analytics';

import { TThunkAction } from 'shared/types/redux';
import { getCustomUrl } from 'shared/utils/formatters/getCustomUrl';

import { getCoworkingData, getPageData, getUserData } from '../selectors';

export const trackPlacementSend = (): TThunkAction => async (_, getState) => {
  const state = getState();
  const { gaData, custom } = state;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_CW',
    action: 'CallBack_popup_place_send',
    label: getCustomUrl(gaData, custom),
    products: [getCoworkingData(state)],
    page: getPageData(state),
    user: getUserData(state),
  });
};
